import {
  SET_ACCESS_CODE_PAGES
} from 'app/actions/types';

import {
  getAccessCodePages as getAccessCodePagesSvc
} from 'app/services/accessCodePages';

export const getAccessCodePages = params => async dispatch => {
  let accessCodePages = await getAccessCodePagesSvc(params);

  if (accessCodePages) {
    dispatch({
      type: SET_ACCESS_CODE_PAGES,
      payload: accessCodePages.params
    });
  }

  return accessCodePages;
}

export const setAccessCodePageParams = params => async dispatch => {
  dispatch({
    type: SET_ACCESS_CODE_PAGES,
    payload: params
  });
}
